import { BaseService } from "./../base";
export class GenderService extends BaseService {
  static get entity() {
    return "gender";
  }
  static get name() {
    return "gender";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }
}
